import type { AmplifyContext } from 'aws-amplify';
import { type SignInInput, type SignInOutput, signIn } from 'aws-amplify/auth';
import type { AlertMessage } from 'components/feedback/alertMessageTypes';

export const resetRequiredSignInAlert: AlertMessage = {
    title: "You can't sign in — a password reset was requested for your account",
    content: [
        {
            type: 'paragraph',
            segments: [
                {
                    text: 'Check your inbox — you have an email with the steps to follow to set up a new password.',
                },
            ],
        },
        {
            type: 'spacer',
            size: 'small',
        },
        {
            type: 'paragraph',
            segments: [
                {
                    text: "If you didn't request any password reset, please report the issue to your system admin or the Control Center support team.",
                },
            ],
        },
    ],
};

const alertMessageToPlainText = (message: AlertMessage) =>
    [
        message.title,
        ...(message.content?.map(block =>
            block.type === 'spacer' ? '' : block.segments.map(segment => segment.text).join('')
        ) ?? []),
    ].join('\n\n');

export const RESET_REQUIRED_SIGN_IN_MESSAGE = alertMessageToPlainText(resetRequiredSignInAlert);

async function handleSignIn(ctx: AmplifyContext, input: SignInInput): Promise<SignInOutput>;
async function handleSignIn(input: SignInInput): Promise<SignInOutput>;
async function handleSignIn(...args: [SignInInput] | [AmplifyContext, SignInInput]): Promise<SignInOutput> {
    const result = args.length === 1 ? await signIn(args[0]) : await signIn(args[0], args[1]);

    if (result.nextStep.signInStep === 'RESET_PASSWORD') {
        throw new Error(RESET_REQUIRED_SIGN_IN_MESSAGE);
    }

    return result;
}

export const authenticatorServices = {
    handleSignIn,
};
